import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  getElementsById,
  getElementsEventDataById,
} from "core-integration/src/store/elements/reducers";
import { fetchEventLive } from "core-integration/src/store/elements/thunks";
import {
  getEntryEventFormation,
  getEntryEventPicks,
} from "core-integration/src/store/entries/reducers";
import { fetchEntryEventPicks } from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getFixturesForEventById } from "core-integration/src/store/fixtures/reducers";
import { fetchFixtures } from "core-integration/src/store/fixtures/thunks";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Link from "../../Link";
import DreamTeam from "../../icons/DreamTeam";
import valueForPlayerElement from "../valueForPlayedElement";

type NullableId = number | null | undefined;

const useEntryEventPitch = (entryId: NullableId, eventId: NullableId) => {
  const dispatch = useDispatch<ThunkDispatch>();

  const entryData = useSelector((state: RootState) =>
    entryId != null && eventId != null
      ? getEntryEventPicks(state, entryId, eventId)
      : null,
  );

  const formation = useSelector((state: RootState) =>
    entryId != null && eventId != null
      ? getEntryEventFormation(state, entryId, eventId)
      : null,
  );

  const elementsById = useSelector(getElementsById);

  const elementsDataById = useSelector((state: RootState) =>
    eventId != null ? getElementsEventDataById(state, eventId) : null,
  );

  const fixturesById = useSelector((state: RootState) =>
    eventId != null ? getFixturesForEventById(state, eventId) : null,
  );

  const teamsById = useSelector(getTeamsById);

  const [pickForMenu, setPickForMenu] = useState<IPickLight | null>(null);

  const handleShowMenuForPickElement = (element: number) => {
    if (!entryData) return;
    const matches = entryData.picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsDataById?.[pick.element]?.stats.in_dreamteam ? (
      <Link to={`/dream-team/${eventId}`}>
        <DreamTeam />
      </Link>
    ) : null;

  // Create a new function on each render as data could have changed and
  // need to ensure a render of connected subcomponents
  const renderPickValue = valueForPlayerElement({
    elementsById,
    elementsDataById,
    fixturesById,
    teamsById,
  });

  const fetchPitchData = useCallback(() => {
    if (entryId == null || eventId == null) return;
    dispatch(fetchEntryEventPicks(entryId, eventId));
    dispatch(fetchEventLive(eventId));
    dispatch(fetchFixtures(eventId));
  }, [dispatch, entryId, eventId]);

  useEffect(() => {
    fetchPitchData();
  }, [fetchPitchData]);

  return {
    entryData,
    formation,
    elementsById,
    elementsDataById,
    fixturesById,
    teamsById,
    pickForMenu,
    handleShowMenuForPickElement,
    handleHideMenuForPick,
    renderDreamTeam,
    renderPickValue,
    fetchPitchData,
  };
};

export default useEntryEventPitch;
